var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterCardLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5073 9.71582H12.0801V24.3797H20.5073V9.71582Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7412 17.0457C12.7401 15.6329 13.0594 14.2384 13.6749 12.9677C14.2903 11.697 15.1859 10.5834 16.2938 9.71113C14.9216 8.6294 13.2738 7.95674 11.5385 7.77002C9.80324 7.58331 8.05062 7.89007 6.48095 8.65524C4.91127 9.42042 3.58787 10.6131 2.66199 12.0971C1.73611 13.581 1.24512 15.2964 1.24512 17.047C1.24512 18.7976 1.73611 20.5129 2.66199 21.9969C3.58787 23.4808 4.91127 24.6736 6.48095 25.4387C8.05062 26.2039 9.80324 26.5107 11.5385 26.3239C13.2738 26.1372 14.9216 25.4646 16.2938 24.3828C15.1856 23.5103 14.2898 22.3963 13.6743 21.1251C13.0588 19.8539 12.7397 18.4589 12.7412 17.0457Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4178 26.3767V25.6576H29.7071V25.5088H29.0186V25.6576H29.2905V26.3767H29.4178ZM30.7544 26.3767V25.5088H30.5461L30.3031 26.1287L30.0601 25.5088H29.8518V26.3767H30.0022V25.7196L30.2279 26.2837H30.3841L30.6097 25.7196V26.3767H30.7544Z",
    fill: "#F79E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7407 17.0483C30.7406 18.7988 30.2692 20.5141 29.3803 21.9979C28.4914 23.4817 27.2208 24.6743 25.7139 25.4393C24.207 26.2042 22.5244 26.5108 20.8586 26.3238C19.1929 26.1368 17.611 25.4639 16.2939 24.382C17.357 23.5091 18.2164 22.3953 18.8074 21.1246C19.3984 19.854 19.7054 18.4597 19.7054 17.047C19.7054 15.6343 19.3984 14.24 18.8074 12.9693C18.2164 11.6987 17.357 10.5849 16.2939 9.71198C17.611 8.63004 19.1929 7.95713 20.8586 7.77016C22.5244 7.5832 24.207 7.88973 25.7139 8.65471C27.2208 9.41969 28.4914 10.6122 29.3803 12.0961C30.2692 13.5799 30.7406 15.2951 30.7407 17.0457V17.0483Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCardLogo);
export default __webpack_public_path__ + "static/media/MasterCardLogo.908b17d7a6375cd077ef7847b823366e.svg";
export { ForwardRef as ReactComponent };